module.exports = __webpack_public_path__ + "static/img/payment-master.8ff6019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-master.png
// module id = JHw5
// module chunks = 0